import React, { PureComponent } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'

// JS
import { startDateFormatString } from '../../../js/constants'

export default class DateAxisTick extends PureComponent {
  static propTypes = {
    x: PropTypes.number,
    y: PropTypes.number,
    payload: PropTypes.object
  }
  render() {
    const { x, y, payload } = this.props

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={-5} y={0} dy={5} textAnchor="end" fill="#666" transform="rotate(-90)" fontSize={12}>
          {moment(payload.value).format(startDateFormatString)}
        </text>
      </g>
    )
  }
}
